<template>
  <settings-modal
    class="accept-card-order-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <template>
      <template slot="actions">
        <v-btn
          class="t-accept-card-order"
          color="primary"
          medium
          flat
          :disabled="acceptCardOrderApiRequest.loading"
          @click="onAcceptCardOrderClick"
        >accept</v-btn>

        <v-btn
          class="t-close-modal"
          color="primary"
          medium
          flat
          @click="closeModal"
        >close</v-btn>
      </template>
  </template></settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { createCardOrderListRoute } from '@/utils/routing/Issuing'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'

  export default {
    name: 'CardOrderInitializedModal',
    components: {
      SettingsModal
    },
    data () {
      return {
        acceptCardOrderApiRequest: new ApiRequest(
          IssuingApi.acceptCardOrder
        )
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      orderId () {
        return this.modal.data.orderId
      },
      heading () {
        return `Accept card order ${this.orderId}?`
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onAcceptCardOrderClick () {
        this.acceptCardOrderApiRequest
          .execute(this.orderId)
          .then(this.onCardOrderAcceptSuccess)
          .catch(this.onCardOrderAcceptError)
      },
      onCardOrderAcceptSuccess () {
        this.showModal({
          name: 'SuccessFlashModal',
          data: {
            redirectPath: createCardOrderListRoute(),
            message: 'Card order has been successfully accepted.'
          }
        })
      },
      onCardOrderAcceptError (response) {
        this.showModal({
          name: 'ErrorFlashModal',
          timeout: 3000,
          data: {
            message: `<p>Card order has not been accepted. Reason:<br><strong>- ${response.errors[0].message}.</strong></p>`
          }
        })
      }
    }
  }
</script>
